import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 2C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C4.98028 22 4.9606 21.9998 4.94096 21.9994L4.94097 21.9983L4.82373 21.9949C3.24892 21.9037 2 20.5977 2 19V5C2 3.34315 3.34315 2 5 2H19ZM16 11.415L7.414 20H19C19.5128 20 19.9355 19.614 19.9933 19.1166L20 19V15.415L16 11.415ZM19 4H5C4.44772 4 4 4.44772 4 5V19C4 19.4289 4.27003 19.7948 4.64936 19.9368L15.2929 9.29289C15.6534 8.93241 16.2206 8.90468 16.6129 9.2097L16.7071 9.29289L20 12.585V5C20 4.48716 19.614 4.06449 19.1166 4.00673L19 4ZM8.5 6C9.88071 6 11 7.11929 11 8.5C11 9.88071 9.88071 11 8.5 11C7.11929 11 6 9.88071 6 8.5C6 7.11929 7.11929 6 8.5 6ZM8.5 8C8.22386 8 8 8.22386 8 8.5C8 8.77614 8.22386 9 8.5 9C8.77614 9 9 8.77614 9 8.5C9 8.22386 8.77614 8 8.5 8Z"
        fill="#191919"
      />
    </Svg>
  );
};

export default Icon;
